import { render, staticRenderFns } from "./VDaterange.vue?vue&type=template&id=96671d12&scoped=true&"
import script from "./VDaterange.vue?vue&type=script&lang=js&"
export * from "./VDaterange.vue?vue&type=script&lang=js&"
import style0 from "./VDaterange.vue?vue&type=style&index=0&id=96671d12&scoped=true&lang=stylus&"
import style1 from "./VDaterange.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96671d12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VCardText,
  VCardTitle,
  VDatePicker,
  VLayout,
  VList,
  VListTile,
  VListTileContent,
  VMenu,
  VSpacer,
  VSubheader,
})
